module.exports = __webpack_public_path__ + "media/home/HeroCover-cadf04ea.png";